import { Component, OnInit, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import * as $ from 'jquery';
import { SatisfactionComponent } from "app/admin/satisfaction/satisfaction.component";
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { Globals } from 'app/globals';
import { AdminService, QuestionDto } from 'app/services/admin/AdminService';

@Component({
  selector: 'app-new-satisfaction-modal',
  templateUrl: './new-satisfaction-modal.component.html',
  styleUrls: ['./new-satisfaction-modal.component.scss']
})
export class NewSatisfactionModalComponent implements OnInit {
    @ViewChild('newsatisfaction', {static: true}) public modal: ModalDirective;
    @ViewChild('modalContent', {static: true}) modalContent: ElementRef;
    parent: any;
    text: string = "";
    actionEdit: boolean = false;
    actionCreate: boolean = false;
    currentIndex: number;
    languages: string[] = [];
    localizations: any[] = [];
    questionId: number;
    type: number;
    action: string;
    levels: any[] = [1, 2, 3, 4, 5, 6, 7];
    negativelyKeyed: boolean = false;
    testQuestion: boolean = false;
    currentLevel: number;
    parentName: string = '';
    categories: any[] = [];
    category: number;

  @Output() modalSave: EventEmitter<any> = new EventEmitter<any>();
  constructor
      (
          private _AdminService: AdminService,
          private toastr: ToastrService,
          private router: Router,
          private _Globals: Globals
          )
      { }

  ngOnInit() {
      this.getLanguages();
  }

    getLanguages() {
        this._AdminService.getLanguages().subscribe((data: any) => {
          console.log('languages', data.result);
          let result = data.result.Result;
          
          if (result <= -10) {
              //this.toastr.warning('Expired token please login again.', 'ELI');
              this.router.navigate(['/login']);
              this._Globals.deleteAllStorage();
              return;
          }
          let _data = JSON.parse(data.result.Data);
          this.languages = _data;
      });
    }

    getQuestionCategories() {
        this._AdminService.getQuestionCategories().subscribe((data: any) => {
            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                this.categories = _data;
                console.log('getQuestionCategories', _data);

                //setting the first option by default
                if (this.actionCreate) {
                    this.category = this.categories[0].Id;
                }
            }
        });
    }

  //getQuestion() {
      //this._getQuestion.getQuestion(this.questionId).subscribe((_data: any) => {
          //console.log('question', data.result);
          //this.currentLevel = data.result.Level;
          //$("#levels").val(data.result.Level);
          //this.currentNegativelyKeyed = data.result.NegativelyKeyed;
          ////this.negativelyKeyed = this.currentNegativelyKeyed;
          //if (this.currentNegativelyKeyed) {
          //    $('#checkbox2').prop('checked', true);
          //}
          //this.localizations = data.result.Localizations;
      //})
    //}

    getQuestion() {
        this._AdminService.getQuestion(this.questionId).subscribe((_data: any) => {

            console.log('response_getQuestion', _data);
            if (this._Globals.validationToken(_data.result.Result)) {
                let data = JSON.parse(_data.result.Data);
                console.log('question', data);

                if (this.type == 5) {
                    this.category = data.Category;
                    //setting the first option by default
                    if (this.category == 0) {
                        this.category = this.categories[0].Id;
                    }
                }

                this.currentLevel = data.Level;
                $("#satLevels").val(data.Level);
                this.negativelyKeyed = data.NegativelyKeyed;
                if (this.negativelyKeyed) {
                    $('#sadCheckbox2').prop('checked', true);
                }

                this.testQuestion = data.IsTestQuestion;
                if (this.testQuestion) {
                    $('#satCheckboxTest').prop('checked', true);
                }
                this.localizations = data.Localizations;
            }
        })
    }

    show(text: string, parent: any, action, questionId, sectionType, boolGetAllQuestions: boolean): void {
      $('#satLevels option').eq(0).prop('selected', true);
      $('#satCheckbox2').prop('checked', false); // Unchecks it
        this.parentName = parent.sectionName;
        this._Globals.boolGetAllQuestions = boolGetAllQuestions;

      this.type = sectionType;

      $('#satisfactionTextarea').val(text);
      this.text = text;
      this.parent = parent;
      this.questionId = questionId;
      this.action = action;
      switch (action) {
          case "edit":
              this.actionEdit = true;
              this.getQuestion();
              break;
          case "create":
              this.actionCreate = true;
              break;
      }
      if (this.type == 5) {
          this.getQuestionCategories();
      }
      this.modal.show();
  }

  onShown(): void {
  }

  close(): void {
      this.modal.hide();
      this.resetActions();
      this.negativelyKeyed = false;
      this.testQuestion = false;
  }

  resetActions() {
      this.actionCreate = false;
      this.actionEdit = false;
      $('#satisfactionLanguages').prop('selectedIndex', 0);
  }

  saveQuestion(text: string) {
      if (text == '') {
          this.toastr.warning('Field empty', 'ELI');
          return;
      }

      let questionId = 0;
      if (!this.actionCreate) {
          questionId = this.questionId;
      }

      let negativelyKeyed = 0;
      if (this.negativelyKeyed) {
          negativelyKeyed = 1;
      }

      let testQuestion = 0;
      if (this.testQuestion) {
          testQuestion = 1;
      }

      let questionDto = new QuestionDto();
      questionDto.Id = questionId;
      questionDto.Type = this.type;
      questionDto.Levels = parseInt($('#satLevels').val().toString());
      questionDto.NegativelyKeyed = negativelyKeyed;
      questionDto.IsTestQuestion = testQuestion;
      questionDto.Localizations = this.localizations;
      if (this.type == 5) { // 360
          questionDto.Category = this.category;
      } else {
          questionDto.Category = 0;
      }

      this._AdminService.postSaveQuestion(questionDto).subscribe(data => {
          console.log('postSaveQuestion response', data);
          if (data.result.Result != 0) {
              this.toastr.success('Edited successfully.', 'ELI');
              if (this._Globals.boolGetAllQuestions) {
                  this.parent.getAllQuestions();
              } else {
                  console.log("TYPE", this.type);
                  let gridApi;
                  if (this.type == 2) {
                      gridApi = this.parent.satisfactionGridApi;
                  } else {
                      gridApi = this.parent.section2GridApi;
                  }
                  this.parent.updateRowEntry(gridApi, this.parent.currentRowIndex, this.localizations[0].Text, this.testQuestion);
              } 
              this.close();
          }
          else {
              this.toastr.error('Error. Please try again.', 'ELI');
          }
      });
      //this.questionEmpty(text);
      //this.parent.insertNewRow(text);
      //this.modalSave.emit();
  }

    changeNegativelyKeyedStatus() {
      this.negativelyKeyed = !this.negativelyKeyed;
      console.log(this.negativelyKeyed);
    }


    changeTestQuestionStatus() {
        this.testQuestion = !this.testQuestion;
        console.log(this.testQuestion);
    }
       

  editQuestion() {
      //this.questionEmpty(text);
      //this.parent.editRow(text, this.currentIndex);
      //this.close();
  }

  questionEmpty(text) {
      if (text == "") {
          $('#satisfactionTextarea').addClass('empty');
          setTimeout(function () {
              $('#satisfactionTextarea').removeClass('empty');
          }, 500);
          return;
      }
  }

  addLocalization(text: string, languageShortCode: string) {
      if (text != '') {
          console.log('setLocalization');
          if (this.localizations.length == 0) {
              this.localizations.push({ "LanguageShortCode": languageShortCode, "Text": text });
          }
          else {

              let arrayLength = this.localizations.length;
              let addNew = true;
              for (var i = 0; i < arrayLength; i++) {
                  if (this.localizations[i].LanguageShortCode == languageShortCode) {
                      //property exist
                      addNew = false;
                      this.localizations[i].Text = text;
                  }
              }
              if (addNew) {
                  //property not exist
                  this.localizations.push({ "LanguageShortCode": languageShortCode, "Text": text });
              }
          }
          console.log(this.localizations);
      }
  }

  clearTextArea() {
      $('#satisfactionTextarea').val('');
  }

  checkData(languageShortCode: string) {
      this.clearTextArea();
      console.log('check data', this.localizations);

      //check array for display data in text area if exist
      let arrayLength = this.localizations.length;
      for (var i = 0; i < arrayLength; i++) {
          if (languageShortCode == this.localizations[i].LanguageShortCode) {
              //property exist
              let text = this.localizations[i].Text;
              $('#satisfactionTextarea').val(text);
          }
      }

  }

  preventSpace(value: string, event: any) {
      if (value == null || value == "") {
          if (event.keyCode == 32) {
              return false;
          }
      }
      if (value == " ") {
          $('#satisfactionTextarea').val('');
      }
  }


}

interface HTMLInputEvent extends Event {
    target: HTMLInputElement & EventTarget;
}
